import { useState, useEffect, Fragment } from "react";
import dynamic from "next/dynamic";

import { dehydrate, QueryClient, useQuery } from '@tanstack/react-query';
import { getQueryFn, queryKeyManager } from "../../../utils/api/queryFunction";
import queryConfig from "../../../utils/api/queryConfig";
import { hasProperty } from "../../../utils/validate";

const SEO = dynamic(() => import("../../../components/Shared/SEO"));
const ProductLayout = dynamic(() => import('../../../components/Layout/ProductLayout'));
const SmallBanner = dynamic(() => import('../../../components/Shared/Banners/SmallBanner'));
const BATD = dynamic(() => import('../../../components/Category/BATD/BATD'));

const BATDPage = props => {
	const { token } = props;

	const { isLoading, isError, data } = useQuery({
		queryKey: queryKeyManager(['motorcycles', 'book-a-test-ride'], [token]),
		queryFn: () => getQueryFn(`motorcycles/batd`, token),
		...queryConfig
	})

	if (isLoading) {
		return <span />
	}

	if (hasProperty(data, 'error') || isError){
		return <Error error={data.error} errorCode={data.error.code}  />
	}

	const [formData, setFormData] = useState();

	useEffect(() => {
		async function getFormData(){
			if (hasProperty(data, "form") && data.form != null && data.form.handle) {
				let formResponse = await getQueryFn(`form/${data.form.handle}`);
				setFormData(formResponse);
			}
		}
		getFormData();
	}, [data]);

	return (
		<Fragment>
			<SEO seo={data.seo}/>
			<ProductLayout nav={data.nav.header.links} logo={data.nav.header.logos.motorcycles} root="motorcycles" footer={data.nav.footer}>
				<SmallBanner banner={data.banner}/>
				{formData &&
					<BATD
						pageData={data.productList}
						category={data.category}
						title='Choose your motorcycle:'
						intro='Choose up to three motorcycles'
						formTitle='Explore motorcycles'
						formData= {formData}
						spec={data.dealerSpec}
						thankYou='/motorcycles/book-a-test-ride/thank-you'
					/>
				}
			</ProductLayout>
		</Fragment>
	);
};

BATDPage.getInitialProps = async ({ query, req }) => {
	const queryClient = new QueryClient();
	const { token } = query;
	await queryClient.prefetchQuery({
		queryKey: queryKeyManager(['motorcycles', 'book-a-test-ride'], [token]),
		queryFn: () => getQueryFn(`motorcycles/batd`, token),
		...queryConfig
	});
	return {
		token: token,
		dehydratedState: dehydrate(queryClient)
	};
};


export default BATDPage;